import { useEffect, useState } from 'react';
import useLocalStorage from '../useLocalStorage/useLocalStorage';
import getListFromReferential from '../../services/SearchVehicle/getListFromReferential';

export const useMakeModelFilters = (filtersState) => {
  const [makeLists, setMakeLists] = useLocalStorage('make', []);
  const [modelLists, setModelLists] = useState([]);
  const { brandName } = filtersState;
  let scope = 'makes';

  useEffect(() => {
    if (makeLists.length === 0) getListFromReferential({}, scope).then((res) => setMakeLists(res));
  }, []);

  useEffect(() => {
    if (!brandName?.value) setModelLists([]);
    if (makeLists.length > 0) scope = 'models';
    if (scope === 'models' && brandName?.value) {
      const selectedMake = makeLists.filter((make) => make.name === brandName?.value);
      getListFromReferential({ makeId: selectedMake[0].id }, scope).then((res) => {
        if (scope === 'makes') setMakeLists(res);
        else setModelLists(res);
      });
    }
  }, [brandName?.value]);

  return { makeLists, modelLists };
};
